var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"step-heading"},[_vm._v("Step "+_vm._s(_vm.step)+" of "+_vm._s(_vm.steps)+" - "+_vm._s(_vm.stepName))]),_vm._v(" "),_c('div',{staticClass:"step-bar"},_vm._l((_vm.steps),function(stepNumber){return _c('span',{key:stepNumber,staticClass:"step-bar__step",class:{ 'step-bar__step--active': _vm.step >= stepNumber }})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }